import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    isLoading : true,
    userRoles: [],
    totalUserRoles: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    
};


const allUserRoleSlice = createSlice({
    name: "allUserRoles",
    initialState,
    reducers:{
        getAllUserRolePending: (state) => {
            state.isLoading = true;
        },
        getAllUserRoleSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.userRoles = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getAllUserRoleFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
    },
});

const { reducer, actions } = allUserRoleSlice;

export const { getAllUserRolePending, getAllUserRoleSuccess, getAllUserRoleFail } = actions;

export default reducer;
